import { OverlayTrigger } from 'react-bootstrap'
import { Tooltip } from 'react-bootstrap'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

export const ToolTipUI = ({ tooltipText, isYellowCaution, isRedCaution, margin }: { tooltipText?: string, isYellowCaution?: string, isRedCaution?: string, margin?: string }) => {
  return (
    <>
      <OverlayTrigger
        placement='bottom'
        overlay={
          <Tooltip id='tooltip'>
            <p className='mx-4 m-0'> {tooltipText}</p>
          </Tooltip>
        }
      >
        {isYellowCaution ? <img
          src={toAbsoluteUrl('/media/logos/triangle-caution-yellow.svg')}
          alt='Tooltip'
          className='text-secondary ms-1'
          width='24px'
          height='24px'
        /> : isRedCaution ? <img
          src={toAbsoluteUrl('/media/logos/triangle-caution-red.svg')}
          alt='Tooltip'
          className='text-secondary ms-1'
          width='24px'
          height='24px'
        /> :
          <img
            src={toAbsoluteUrl('/media/icons/duotune/general/tooltip.svg')}
            alt='Tooltip'
            className={`text-secondary ${margin ? margin : "ms-1"}`}
            width='18px'
            height='18px'
          />
        }
      </OverlayTrigger>
    </>
  )
}
